import { AlertCircle } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { useLocale } from "@/features/i18n/locale-provider";
import { Section } from "./section";

/** Skeleton shaped like the pages it replaces, so nothing jumps on load. */
export function PageSkeleton() {
  return (
    <div className="animate-fade">
      <Skeleton className="h-[clamp(20rem,45vw,28rem)] w-full rounded-none" />
      <Section padding="default">
        <div className="mx-auto max-w-reading space-y-4">
          <Skeleton className="h-4 w-32" />
          <Skeleton className="h-12 w-full" />
          <Skeleton className="h-12 w-4/5" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-3/4" />
        </div>
      </Section>
    </div>
  );
}

export function ErrorState({ onRetry }: { onRetry?: () => void }) {
  const { t } = useLocale();

  return (
    <Section padding="loose">
      <div className="mx-auto flex max-w-[38rem] flex-col items-center text-center">
        <AlertCircle className="mb-5 size-8 text-ink/40" strokeWidth={1.5} />
        <h1 className="text-h2">{t("state.errorTitle")}</h1>
        <p className="mt-4 text-lead text-ink-muted">{t("state.errorBody")}</p>
        {onRetry && (
          <Button variant="secondary" className="mt-7" onClick={onRetry}>
            {t("state.retry")}
          </Button>
        )}
      </div>
    </Section>
  );
}

export function EmptyState({ message }: { message?: string }) {
  const { t } = useLocale();
  return <p className="py-8 text-center text-body text-ink-soft">{message ?? t("state.empty")}</p>;
}
